module.exports = __webpack_public_path__ + "images/help/video-ical@2x-a8fa5f968096153ecc171e28c6f3e584.png";